import styled from "@emotion/styled"
export const MyCardOne = {
    block: styled.div`
        overflow: hidden;
        box-sizing: border-box;
        max-width: 560px;
        position: relative;
        border: solid 1px #DCDCDC;
        border-radius: 24px;
        background: #F5F5F5;
        margin-right: 20px;
        min-height: 100%;
    `,
    wrapper: styled.div`
        padding: 24px 32px;
        min-height: 219px;
    `,
    title: styled.h3`
        font-family: 'Shell Heavy';
        line-height: 160%;
        font-size: 14px;
        margin: 0;
        display: block;
        min-height: 58px;
        
        @media ( min-width: 769px) {
            font-size: 18px;
        }
    `,

    wraoImage: styled.figure`
        width: 100%;
        margin: 0;
    `,
    image: styled.img`
        display: block;
        max-width: 100%;
    `,
    validity: styled.p`
        font-family: 'Shell Book';
        line-height: 160%;
        font-size: 12px;
        margin-top: 6px;
        
        @media ( min-width: 769px) {
            font-size: 16px;
        }
    `,
    CTA: styled.a`
        margin-top: 24px;
        font-family: 'Shell Medium';
        text-decoration: none;
        text-align: center;
        width: fit-content;
        border-radius: 8px;
        display: block;
        padding: 13px 20px;
        line-height: 17px;
        font-size: 14px;

        @media ( min-width: 769px) {            
            line-height: 23.15px;
            font-size: 17.36px;
            padding: 17px 27px;
        }

        .active-promotion & {
            background-color: #DD1D21;
            color: #ffffff;
        }

        .inactive-promotion & {
            background-color: #FFBD2F;
            color: #3B3B3B;
        }
    `,
}